var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PChart',{attrs:{"type":"line","title":"Analytics","height":"250","series":_vm.series,"x-axis":_vm.xAxis}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }